import axios from "axios";

export default {
    getCompanyFlextimeSettings: async (companyId) => {
        const { data } = await axios.get(`/flextime/settings/company/${companyId}`)

        return data
    }
}
